module.exports = new __parcel__URL__("Error.09b29c7d.svg").toString();